import { render, staticRenderFns } from "./audit.vue?vue&type=template&id=88089c3e"
import script from "./audit.vue?vue&type=script&lang=js"
export * from "./audit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88089c3e')) {
      api.createRecord('88089c3e', component.options)
    } else {
      api.reload('88089c3e', component.options)
    }
    module.hot.accept("./audit.vue?vue&type=template&id=88089c3e", function () {
      api.rerender('88089c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/audit/sku/ordinaryCSG/audit.vue"
export default component.exports